import Image from 'next/image';

import { getEdgeUrl } from '@/lib/getEdgeUrl';
import i18n from '@/settings/i18n';

const t = i18n.init('buyback');

const TradeInHero = () => {
  const leftSectionDesktop = getEdgeUrl(
    'images/buyback/landing/banner/left-section-desktop-buyback.png',
  );
  const rightSectionDesktop = getEdgeUrl(
    'images/buyback/landing/banner/right-section-desktop-buyback.png',
  );
  const rightSectionMobile = getEdgeUrl(
    'images/buyback/landing/banner/mobile-right-buyback.png',
  );

  return (
    <div className="relative flex w-screen flex-col justify-center overflow-hidden bg-teal-500 py-5 text-gray-700 xxs:h-[116px] sm:py-0 md:h-[207px] md:items-center">
      {/* Left Block Desktop  */}
      <div className="absolute bottom-0 hidden md:left-[-120px] md:block lg:left-0">
        <div className="h-[207px]">
          <Image
            src={leftSectionDesktop}
            alt={t`Left Section`}
            loading="eager"
            height={800}
            width={800}
            className="h-full w-auto"
            priority
          />
        </div>
      </div>
      {/* Right Block Desktop */}
      <div className="absolute bottom-0 hidden md:right-[-100px] md:block lg:right-0">
        <div className="h-[207px]">
          <Image
            src={rightSectionDesktop}
            alt={t`Right Section`}
            loading="eager"
            height={800}
            width={800}
            className="h-full w-auto"
            priority
          />
        </div>
      </div>

      {/* Right Block Mobile */}
      <div className="absolute right-0 top-0 h-full sm:h-[116px] md:hidden">
        <Image
          src={rightSectionMobile}
          alt={t`Right Section`}
          loading="eager"
          height={800}
          width={800}
          className="h-full w-auto object-cover opacity-30 xxs:opacity-100"
          priority
        />
      </div>
      <div className="relative">
        <div className="reebelo-container">
          <div className="flex w-full flex-col text-center xxs:max-w-[250px] xxs:text-left xs:max-w-[380px] md:max-w-[350px] md:items-center md:justify-center md:text-center xl:max-w-full">
            <h1 className="text-lg font-bold !leading-tight md:text-2xl xl:text-3xl">
              {t`Trade In Your Tech For Cash`}
            </h1>
            <p className="mt-1 text-sm !leading-tight md:text-base">
              {t`Instant quote. Free shipping. Fast payout.`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradeInHero;
